import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseComponent, FabProcessStep, Grid, ModalSize } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { FabProcessStepComponent } from './fab-process-step.component'

@Component({
    selector: 'app-fab-process-steps-list',
    templateUrl: './fab-process-steps-list.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
    ],
})
export class FabProcessStepsListComponent extends BaseComponent implements OnChanges {
    @Input() canEdit = false
    @Input() items: FabProcessStep[] = []
    @Output() modified = new EventEmitter<void>()

    grid: Grid<FabProcessStep>

    constructor() {
        super()
        this.grid = new Grid<FabProcessStep>(this.services)
            .setupModalEditing(
                this.services.data.fabProcessSteps,
                'Process Step',
                FabProcessStepComponent,
                () => {
                    const step = new FabProcessStep()
                    step.id = crypto.randomUUID()
                    step.active = true
                    step.colorHex = '#CCCCCC'
                    step.leadTimeDays = 0
                    step.progressWeight = 0
                    step.sortOrder = 0
                    step.category = 'Fabrication'
                    return step
                },
                this,
                ModalSize.medium,
            )
            .filterBy(item => [item.name, item.colorHex, item.category])
            .isReadOnly(true)

        this.grid.itemAdded.on(() => this.modified.emit())
        this.grid.itemEdited.on(() => this.modified.emit())
        this.grid.itemsDeleted.on(() => this.modified.emit())
        this.initialLoadingComplete()
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['items']) {
            this.grid.items = this.items || []
        }
    }
}
